import { HttpErrorResponse } from "@angular/common/http";

const WHOLE_REQUEST_ERROR_KEYS = ["detail", "non_field_errors"];

/** Reduces any HTTP error body to a single readable line for a notification. */
export function httpErrorMessage(err: HttpErrorResponse): string {
  const body = err.error;
  const messages = isPlainObject(body)
    ? // DRF validation body: label each field, except its whole-request keys.
      Object.entries(body).flatMap(([field, value]) => {
        const texts = flattenErrorMessages(value);
        return texts.length && !WHOLE_REQUEST_ERROR_KEYS.includes(field)
          ? [`${field}: ${texts.join(" ")}`]
          : texts;
      })
    : flattenErrorMessages(body);

  // err.message is the "Http failure response for <url>: 502 Bad Gateway"
  // fallback for bodies that carry nothing readable (HTML pages, network errors).
  return messages.join(" ") || err.message;
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return (
    !!value &&
    typeof value === "object" &&
    !Array.isArray(value) &&
    !(value instanceof ProgressEvent) &&
    !(value instanceof Error)
  );
}

/** Pulls the readable strings out of an error body of any shape:
 *  "msg", ["msg"], {field: ["msg"]}, {field: {detail: "msg"}}, and nestings thereof.
 *  Skips HTML bodies (nginx/gateway error pages) so they never reach a notification. */
function flattenErrorMessages(value: unknown): string[] {
  if (typeof value === "string") {
    const text = value.trim();
    return text && !text.startsWith("<") ? [text] : [];
  }
  if (Array.isArray(value)) return value.flatMap(flattenErrorMessages);
  if (isPlainObject(value)) {
    return Object.values(value).flatMap(flattenErrorMessages);
  }
  return [];
}
